export const carouselInicio = [
    
   
    {
        "imagen" : "/assets/imgs/IMG_5027.png",
        "url": ""
    },
    {
        "imagen" : "/assets/imgs/IMG_602.png",
        "url": ""
    },
    {
        "imagen" : "/assets/imgs/IMG_520.png",
        "url": ""
    },
    {
        "imagen" : "/assets/imgs/IMG_653.png",
        "url": ""
    },





]